<template>
	<div>
		<div v-if="value==1">
			<el-row class="crumbs-box">
				<el-row>
					<el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
						<el-breadcrumb-item>当前位置</el-breadcrumb-item>
						<el-breadcrumb-item>图片管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-row>
				<el-row class="selectbox">
					<el-col :span="2" class="seachTitleContent">
						渠道分类:
					</el-col>
					<el-col :span="2" class="selectInputBox">
						<select class="select" v-model="searchForm.chnanelName">
							<option value="全部">全部</option>
							<option value="PC">PC</option>
							<option value="M">M站</option>
						</select>
					</el-col>
					<el-col :span="2" class="seachTitleContent">
						图片位置:
					</el-col>
					<el-col :span="2" class="selectInputBox">
						<select class="select" v-model="searchForm.siteName">
							<option value="全部">全部</option>
							<option value="首页轮播图">首页轮播图</option>
							<option value="底部轮播图">底部轮播图</option>
							<option value="品牌图片">品牌图片</option>
						</select>
					</el-col>
					<el-col :span="1" class="seachTitleContent">
						状态:
					</el-col>
					<el-col :span="2" class="selectInputBox">
						<select class="select" v-model="searchForm.statusName">
							<option value="全部">全部</option>
							<option value="待发布">待发布</option>
							<option value="已发布">已发布</option>
						</select>
					</el-col>
					<el-col :span="2" class="seachTitleContent">
						创建人:
					</el-col>
					<el-col :span="2">
						<input type="text" class="select" v-model="searchForm.userValue">
					</el-col>
					<el-col :span="1" :offset="1">
						<button @click="search" class="searchbtn">查询</button>
					</el-col>
					<el-col :span="1" style="margin-left: 20px;">
						<button @click="reset" class="resetbtn">重置</button>
					</el-col>
				</el-row>
			</el-row>
			<el-row class="formbox">
				<el-row class="addbox">
					<el-col :span="3">
						<button @click="add" class="searchbtn">新增</button>
					</el-col>
				</el-row>
				<el-row>
					<table class="tablebox" v-if="issearch==false">
						<tr class="table-firsttitle">
							<td>渠道分类</td>
							<td>图片位置</td>
							<td>图片名称</td>
							<td>排序</td>
							<td>状态</td>
							<td id="timeBox">操作时间</td>
							<td id="timeBox">创建时间</td>
							<td>创建人</td>
							<td>操作</td>
						</tr>
						<tr class="table-trtitle" v-for="item in list">
							<td>{{item.chnanelTypeName}}</td>
							<td>{{item.picturetypeName}}</td>
							<td :title="item.pictureName">
								<p class="tableTitle">{{item.pictureName}}</p>
							</td>
							<td>{{item.sort}}</td>
							<td>{{item.statusName}}</td>
							<td>{{item.updateTime}}</td>
							<td>{{item.createTime}}</td>
							<td>
								<p class="tableTitle" :title="item.createName">
									{{item.createName}}
								</p>
							</td>
							<td v-if="item.statusName=='已发布'" @click="soldOut(item)" class="operateColor">下架</td>
							<td v-else class="operateColor">
								<span @click="edit(item)">编辑</span>
								<span @click="issue(item)">发布</span>
								<span @click="del(item)">删除</span>
							</td>
						</tr>
					</table>
					<table class="tablebox" v-else>
						<tr class="table-firsttitle">
							<td>渠道分类</td>
							<td>图片位置</td>
							<td>图片名称</td>
							<td>排序</td>
							<td>状态</td>
							<td id="timeBox">操作时间</td>
							<td id="timeBox">创建时间</td>
							<td>创建人</td>
							<td>操作</td>
						</tr>
						<tr class="table-trtitle">
							<td>{{searchList.chnanelTypeName}}</td>
							<td>{{searchList.picturetypeName}}</td>
							<td :title="searchList.pictureName">
								<p>{{searchList.pictureName}}</p>
							</td>
							<td>{{searchList.sort}}</td>
							<td>{{searchList.statusName}}</td>
							<td>{{searchList.updateTime}}</td>
							<td>{{searchList.createTime}}</td>
							<td>{{searchList.createName}}</td>
							<td v-if="searchList.statusName=='已发布'" @click="soldOut(searchList)" class="operateColor">下架</td>
							<td v-else class="operateColor">
								<span @click="edit(searchList)">编辑</span>
								<span @click="issue(searchList)">发布</span>
								<span @click="del(searchList)">删除</span>
							</td>
						</tr>
					</table>
					<div class="block" style="margin-top: 20px;">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="currentPage"
							:page-sizes="[10,20,30]"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total">
					    </el-pagination>
					</div>
				</el-row>
			</el-row>
		</div>
		
		<!-- 新增 & 编辑 -->
		<div v-else-if="value==2" id="add">
			<el-row class="add-title">
				新增图片
			</el-row>
			<el-row class="add-input">
				<el-col :span="3" class="title">
					<span class="must">*</span>图片位置:
				</el-col>
				<el-col :span="10" :offset="1">
					<select class="select" @change="imgType" v-model="form.picturetypeName">
						<option value="首页轮播图">首页轮播图</option>
						<option value="底部轮播图">底部轮播图</option>
						<option value="合作品牌图片">合作品牌图片</option>
					</select>
				</el-col>
			</el-row>
			<div v-for="item in showformList">
				<el-row class="add-input" v-if="item=='chnanelTypeName'">
					<el-col :span="3" class="title">
						<span class="must">*</span>客户端:
					</el-col>
					<el-col :span="10" :offset="1">
						<select class="select" @click="clientType" v-model="form.chnanelTypeName">
							<option value="" selected style="display: none;">PC</option>
							<option value="PC">PC</option>
							<option value="M">M站</option>
						</select>
					</el-col>
				</el-row>
				<el-row class="add-input" v-if="item=='pictureName'">
					<el-col :span="3" class="title">
						<span class="must">*</span>图片名称:
					</el-col>
					<el-col :span="10" :offset="1">
						<input v-model="form.pictureName" class="select" maxlength="100">
					</el-col>
				</el-row>
				
				<!-- 选择是否是首页轮播图 -->
				<el-row v-if="isupload==true">
					<el-row class="add-input" v-if="item=='radio'">
						<el-col :span="3" class="title">
							<span class="must" v-if="isradio">*</span>上传:
						</el-col>
						<el-col :span="4" :offset="1">
							<el-radio v-model="radio" value="图片" label="1" @change="radioData">图片</el-radio>
							<el-radio v-model="radio" value="视频" label="0" @change="radioData">视频</el-radio>
						</el-col>
					</el-row>
					<!-- 选择视频和图片 -->
					<el-row v-if="isradio==true">
						<el-row class="add-input" v-if="item=='pictureUrl'">
							<el-col :span="20" :offset="4">
								<el-row>
									<el-col :span="20" v-if="ispictureUrl==false">
										<el-upload action="/api/upload" list-type="picture-card" :on-success="success" :on-remove="remove"
											:before-upload="beforeAvatarUpload" :limit="1" style="float: left;">
											<i class="el-icon-plus"></i>
										</el-upload>
									</el-col>
									<el-col :span="20" style="height: 150px;margin-top: 20px;" v-else>
										<div @click="moveClick">
											<div class="imghover">
												<img width="100%" :src="form.pictureUrl" class="form-img" @mouseover="mouseover" @mouseleave="mouseleave">
											</div>
											<div class="icon" v-if="move">
												<i class="el-icon-delete"></i>
											</div>
										</div>
									</el-col>
								</el-row>
								<el-row class="size" v-if="size=='homePc'">
									尺寸：1920px*715px 大小：500MB
								</el-row>
								<el-row class="size" v-else-if="size=='bottomPc'">
									尺寸：1600px*340px 大小：500MB
								</el-row>
								<el-row class="size" v-else-if="size=='logoPc'">
									尺寸：270px*270px 大小：500MB
								</el-row>
								<el-row class="size" v-else-if="size=='homeM'">
									尺寸：750px*420px 大小：500MB
								</el-row>
								<el-row class="size" v-else-if="size=='bottomM'">
									尺寸：750px*200px 大小：300MB
								</el-row>
								<el-row class="size" v-else>
									尺寸：210px*210px 大小：300MB
								</el-row>
							</el-col>
						</el-row>
					</el-row>				
					
					<el-row v-else>
						<el-row class="add-input" v-if="item=='videoUrl'">
							<el-col :span="20" :offset="4">
								<el-row>
									<el-col :span="20" v-if="ispictureUrl==false">
										<el-upload action="/api/upload" list-type="picture-card" :on-success="success" :on-remove="remove"
											:before-upload="beforeAvatarUpload" :limit="1" style="float: left;">
											<i class="el-icon-plus"></i>
										</el-upload>
									</el-col>
									<el-col :span="20" style="height: 150px;margin-top: 20px;" v-else>
										<div @click="moveClick">
											<div class="imghover">
												<img width="100%" :src="form.pictureUrl" class="form-img" @mouseover="mouseover" @mouseleave="mouseleave">
											</div>
											<div class="icon" v-if="move">
												<i class="el-icon-delete"></i>
											</div>
										</div>
									</el-col>
								</el-row>
								<el-row class="size">
									尺寸：1920px*715px 大小：500MB
								</el-row>
							</el-col>
						</el-row>
						<el-row class="add-input" v-if="item=='videoUrl'">
							<el-col :span="10" :offset="3" v-if="isvideoUrl==false">
								<el-upload action="/api/uploadVideo" :on-success="handleVideoSuccess" :before-upload="beforeUploadVideo"
									:on-error="handleVideoError" :limit="1" style="float: left;">
									<i class="el-icon-plus"></i>
									上传视频
								</el-upload>
							</el-col>
					
							<el-col :span="20" :offset="3" v-else>
								<video width="100%" :src="form.videoUrl"
								 controls
								 muted
								 class="form-img" @click="video"></video>
							</el-col>
						</el-row>
					</el-row>
				</el-row>
				
				<!-- 底部轮播图 -->
				<el-row v-else>
					<el-row class="add-input" v-if="item=='pictureUrl'">
						<el-col :span="3" class="title">
							上传图片:
						</el-col>
						<el-col :span="20" :offset="4">
							<el-row>
								<el-col :span="20" v-if="ispictureUrl==false">
									<el-upload
									  action="/api/upload"
									  list-type="picture-card"
									  :on-success="success"
									  :on-remove="remove"
									  :before-upload="beforeAvatarUpload"
									  :limit="1"
									  style="float: left;">
									  <i class="el-icon-plus"></i>
									</el-upload>
								</el-col>
								<el-col :span="20" style="height: 150px;margin-top: 20px;" v-else>
									<div @click="moveClick">
										<div class="imghover" @mouseover="mouseover" @mouseleave="mouseleave">
											<img width="100%" :src="form.pictureUrl" class="form-img" @mouseover="mouseover" @mouseleave="mouseleave">
										</div>
										<div class="icon" v-if="move">
											<i class="el-icon-delete"></i>
										</div>
									</div>
								</el-col>
							</el-row>
							<el-row class="size" v-if="size=='homePc'">
								尺寸：1920px*715px 大小：500MB
							</el-row>
							<el-row class="size" v-else-if="size=='bottomPc'">
								尺寸：1600px*340px 大小：500MB
							</el-row>
							<el-row class="size" v-else-if="size=='logoPc'">
								尺寸：270px*270px 大小：500MB
							</el-row>
							<el-row class="size" v-else-if="size=='homeM'">
								尺寸：750px*420px 大小：500MB
							</el-row>
							<el-row class="size" v-else-if="size=='bottomM'">
								尺寸：750px*200px 大小：300MB
							</el-row>
							<el-row class="size" v-else>
								尺寸：210px*210px 大小：300MB
							</el-row>
						</el-col>
					</el-row>
				</el-row>
				<el-row v-if="isradio==true">
					<el-row class="add-input" v-if="item=='url'">
						<el-col :span="3" class="title">
							链接:
						</el-col>
						<el-col :span="10" :offset="1">
							<input class="select" v-model="form.url">
						</el-col>
					</el-row>
				</el-row>
				<el-row class="add-input"  v-if="item=='sort'">
					<el-col :span="3" class="title">
						<span class="must">*</span>排序:
					</el-col>
					<el-col :span="5" :offset="1">
						<input class="select" v-model="form.sort" @change="sortValue">
					</el-col>
				</el-row>
			</div>
			<el-row class="add-input">
				<el-col :span="1" :offset="4">
					<button @click="save" class="savebtn">保存</button>
				</el-col>
				<el-col :span="1" style="margin-left: 20px">
					<button @click="cancel" class="savebtn">取消</button>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import { 
		pictureList ,  //图片列表
		updatePictureStatus,  //下架图片
		deletePicture,  //删除图片
		editPicture,   //编辑图片 & 保存图片
		selectPictureById,   //点击编辑获取数据
	} from '@/api/index.js'
	export default
	{
		data()
		{
			return{
				value:1,
				
				list:[],
				
				imgValue:true,
				
				// 总共页数
				page:1,
				// 每页条数
				pageSize:10,
				// 当前页数
				currentPage:1,
				// 总条数
				total:0,
				
				// 搜索
				issearch:false,
				// 视频
				isvideo:true,
				searchList:{},
				
				// 搜索列表
				searchForm:
				{
					chnanelValue:'',
					chnanelName:'全部',
					siteValue:'',
					siteName:'全部',
					statusValue:'',
					statusName:'全部',
					userValue:''
				},

				// 保存 & 编辑表单
				form:
				{
					picturetype:'',
					chnanelType:'',
					picturetypeName:'首页轮播图',
					chnanelTypeName:'PC',
					pictureName:'',
					pictureUrl:'',
					videoUrl:'',
					url:'',
					sort:'',
					status:'0',
				},
				
				ispictureUrl:false,
				isvideoUrl:false,
				
				showList:['picturetype','chnanelTypeName','pictureName','radio','pictureUrl','videoUrl','url','sort'],
				showformList:[],
				
				// 图片类型
				size:'homePc',
				
				isupload:true,
				radio:'1',
				isradio:true,
				
				move:false,
			}
		},
		created()
		{
			this.isupload=true;
			this.getList();
			this.showformList=['picturetype','chnanelTypeName','pictureName','radio','pictureUrl','videoUrl','url','sort']
		},
		methods:
		{
			// 获取图片数据   
			getList()
			{
				pictureList({page:this.page,pageSize:this.pageSize,picturetype:this.searchForm.siteValue,chnanelType:this.searchForm.chnanelValue,status:this.searchForm.statusValue,createName:this.searchForm.userValue})
				.then((response)=>
				{
					this.currentPage=response.data.data.current;
					this.pageSize=response.data.data.size;
					this.list=response.data.data.records;
					this.total=response.data.data.total;
				})
			},
			// 重新刷新数据
			resetList()
			{
				this.page=1;
				this.pageSize=10;
				this.currentPage=1;
				this.getList()
			},
			// 新增按钮 展示新增页面
			add()
			{
				this.value=2;
				this.form={}
				this.form.picturetypeName='首页轮播图';
				this.form.chnanelTypeName='';
				this.ispictureUrl=false;
				this.isvideoUrl=false;
				this.imgValue=true;
				this.isvideo=true;
				this.isupload=true;
				this.isradio=true;
				this.radio='1';
				this.showformList=['picturetype','chnanelTypeName','pictureName','radio','pictureUrl','videoUrl','url','sort']
			},
			// 当前条数
			handleSizeChange(val) 
			{
				this.page=1;
				this.pageSize=val;
				this.getList()
			},
			// 当前页数
			handleCurrentChange(val) 
			{
				this.page=val;
				console.log(this.page,'当前页数')
				this.getList()
			},
			// 搜索按钮
			search()
			{
				console.log(this.searchForm)
				// 转化为数字传给后台
				if(this.searchForm.chnanelName=='PC')
				{
					this.searchForm.chnanelValue=1;
				}
				else if(this.searchForm.chnanelName=='M')
				{
					this.searchForm.chnanelValue=2;
				}
				else
				{
					this.searchForm.chnanelValue='';
				}
				
				if(this.searchForm.siteName=='首页轮播图')
				{
					this.searchForm.siteValue=1;
				}
				else if(this.searchForm.siteName=='底部轮播图')
				{
					this.searchForm.siteValue=2;
				}
				else if(this.searchForm.siteName=='品牌图片')
				{
					this.searchForm.siteValue=5;
				}
				else
				{
					this.searchForm.siteValue='';
				}
				if(this.searchForm.statusName=='待发布')
				{
					this.searchForm.statusValue=0;
				}
				else if(this.searchForm.statusName=='已发布')
				{
					this.searchForm.statusValue=1;
				}
				else 
				{
					this.searchForm.statusValue='';
				}
				
				pictureList(
				{
					page:1,
					pageSize:10,
					chnanelType:this.searchForm.chnanelValue,
					picturetype:this.searchForm.siteValue,
					status:this.searchForm.statusValue,
					createName:this.searchForm.userValue
				})
				.then((response)=>
				{
					this.currentPage=response.data.data.current;
					this.pageSize=response.data.data.size;
					this.total=response.data.data.total;
					// 判断留言是单条数据还是多条
					if(response.data.data.records.length>1)
					{
						this.issearch=false;
						this.list=response.data.data.records;
					}
					else if(response.data.data.records.length==1)
					{
						this.issearch=true;
						this.searchList=response.data.data.records[0];
					}
					else
					{
						this.open()
						this.issearch=false;
						this.resetList()
					}
					console.log(this.searchForm)
				})
			},
			// 没有数据
			open() 
			{
				this.$alert('请查看是否输入正确', '没有找到相关数据', 
				{
					confirmButtonText: '确定',
				});
			},
			// 重置
			reset()
			{
				this.searchForm=[];
				this.searchForm.chnanelName='全部',
				this.searchForm.siteName='全部',
				this.searchForm.statusName='全部',
				this.issearch=false;
				this.resetList()
			},
			// 删除
			del(item)
			{
				this.$confirm('是否删除数据?', '删除数据',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => 
				{
					deletePicture({data:item})
					.then((response)=>
					{
						this.page=1;
						this.pageSize=10;
						this.$message.success('删除成功')
						this.getList()
					})
				})
				.catch(() =>
				{
					this.$message.info('已取消删除')
					return false;
				})
			},
			// 下架
			soldOut(item)
			{
				if(item.status==1)
				{
					item.status=0;
				}
				updatePictureStatus({data:item})
				.then((response)=>
				{
					console.log(this.page,111)
					this.getList()
				})
			},
			// 发布
			issue(item)
			{
				if(item.status==0)
				{
					item.status=1;
				}
				updatePictureStatus({data:item})
				.then((response)=>
				{
					this.getList()
				})
			},
			// 图片上传
			success(file)
			{
				if(file.data==null)
				{
					this.form.pictureUrl=undefined;
					return false;
				}
				this.form.pictureUrl=file.data;
				this.ispictureUrl=true;
				console.log(this.form,'上传图片里的')
			},
			// 判断图片格式
			beforeAvatarUpload(file) 
			{
				this.move=false;
				if(this.form.chnanelType==1)
				{
					const isJPG = file.type === 'image/jpeg';
					const isPNG = file.type === 'image/png';
					const isLt2M = file.size / 1024 / 1024 < 500;
					
					if (!isJPG && !isPNG)
					{
						this.$message.error('上传图片只能是 JPG,PNG,JPEG 格式!');
					}
					if (!isLt2M)
					{
					  this.$message.error('上传图片大小不能超过 500MB!');
					}
					return isJPG || isPNG && isLt2M;
				}
				else
				{
					const isJPG = file.type === 'image/jpeg';
					const isPNG = file.type === 'image/png';
					const isLt2M = file.size / 1024 / 1024 < 500;
					const isLt3M = file.size / 1024 / 1024 < 300;
					
					if (!isJPG && !isPNG)
					{
						this.$message.error('上传图片只能是 JPG,PNG,JPEG 格式!');
					}
					if(this.form.picturetype==1)
					{
						// 首页轮播图
						if (!isLt2M)
						{
						  this.$message.error('上传图片大小不能超过 500MB!');
						}
					}
					else
					{
						// 底部轮播图  合作品牌图片
						if (!isLt3M)
						{
						  this.$message.error('上传图片大小不能超过 300MB!');
						}
					}
					return isJPG || isPNG && isLt2M;
				}
				
			},
			
			// 删除
			remove()
			{
		        this.form.pictureUrl = ''
			},
			// 视频上传 判断视频格式
			beforeUploadVideo(file)
			{
				const fileSize = file.size / 1024 / 1024 < 100
				console.log(file)
				if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file
					.type) === -1) 
				{
					this.$message.error('请上传正确的视频格式')
					return false
				}
				if (!fileSize) 
				{
					this.$message.error('视频大小不能超过100MB')
					return false
				}
			},
			handleVideoSuccess(res, file) 
			{
				console.log(res)
				this.form.videoUrl=res.data;
				this.isvideoUrl=true;
			},
			handleVideoError(res) 
			{
				console.log(res)
				this.$message.error('上传失败!')
			},
			// 添加-点击图片位置类型
			imgType(e)
			{
				this.form={};
				this.form.picturetypeName='首页轮播图';
				this.form.chnanelTypeName='';
				this.ispictureUrl=false;
				this.form.picturetypeName=e.currentTarget.value;
				if(this.form.picturetypeName=='首页轮播图')
				{
					this.isupload=true;
					this.isradio=true;
					this.form.picturetype="1";
					this.radio='1';
					this.showformList=['picturetype','chnanelTypeName','pictureName','radio','pictureUrl','videoUrl','url','sort']
				}
				else if(this.form.picturetypeName=='底部轮播图')
				{
					this.isupload=false;
					this.isradio=true;
					this.form.picturetype="2";
					this.showformList=['picturetype','chnanelTypeName','pictureName','pictureUrl','url','sort']
				}
				else
				{
					this.isupload=false;
					this.form.picturetype="5";
					this.size='logoPc'
					this.showformList=['picturetype','pictureName','pictureUrl','sort']
				}
			},
			clientType(e)
			{
				this.form.chnanelTypeName=e.currentTarget.value;
				if(this.form.chnanelTypeName=='M')
				{
					this.form.chnanelType="2";
					if(this.form.picturetype==1)
					{
						this.size='homeM'
					}
					else
					{
						this.size='bottomM'
					}
				}
				else
				{
					this.form.chnanelType="1";
					if(this.form.picturetype==1)
					{
						this.size='homePc'
					}
					else
					{
						this.size='bottomPc'
					}
				}
			},
			// 编辑页面
			edit(item)
			{
				this.imgValue=false;
				this.isvideo=false;
				selectPictureById({data:item})
				.then((response)=>
				{
					this.form=response.data.data;
					console.log(this.form,1111111111)
					if(this.form.picturetype==1)
					{
						this.form.picturetypeName='首页轮播图';
						this.imgValue=true;
						this.isvideo=true;
					}
					else if(this.form.picturetype==2)
					{
						this.form.picturetypeName='底部轮播图';
						this.imgValue=true;
						this.isvideo=false;
					}
					else
					{
						this.form.picturetypeName='合作品牌图片';
					}
					if(this.form.chnanelType==1)
					{
						this.form.chnanelTypeName='PC';
					}
					else
					{
						this.form.chnanelTypeName='M';
					}
					if(this.form.videoUrl==null || this.form.videoUrl=='')
					{
						this.isradio=true;
						this.radio='1';
					}
					else
					{
						this.isradio=false;
						this.radio='0';
					}
					if(this.form.pictureUrl=='')
					{
						this.ispictureUrl=false;
					}
					else
					{
						this.ispictureUrl=true;
					}
					if(this.form.videoUrl=='')
					{
						this.isvideoUrl=false;
					}
					else
					{
						this.isvideoUrl=true;
					}
				})
				this.value=2;
			},
			video()
			{
				this.isvideoUrl=false;
			},
			// 添加
			save()
			{
				if(this.form.picturetypeName=='首页轮播图')
				{
					this.form.picturetype="1";
					if(this.form.chnanelTypeName=='')
					{
						this.form.chnanelType='1'
						this.form.chnanelTypeName='PC'
					}
				}
				else if(this.form.picturetypeName=='底部轮播图')
				{
					this.form.picturetype="2";
					if(this.form.chnanelTypeName=='')
					{
						this.form.chnanelType='1'
						this.form.chnanelTypeName='PC'
					}
				}
				else
				{
					this.form.picturetype="5";
					this.form.chnanelType='1,2'
					this.form.chnanelTypeName='PC,M'
				}
				if(this.form.sort<=0)
				{
					this.$message.error('只能输入正整数');
					return false;
				}
				this.verufy()
				if(this.verufy()!=false)
				{
					editPicture({data:this.form})
					.then((response)=>
					{
						this.value=1;
						this.resetList()
					})
				}
			},
			// 取消
			cancel()
			{
				this.form={};
				this.value=1;
			},
			// 校验
			verufy()
			{
				for(var i=0;i<this.showformList.length;i++)
				{
					if(this.form[this.showformList[i]]==undefined || this.form[this.showformList[i]]=='')
					{
						if(this.isupload==true)
						{
							if(this.isradio==true)
							{
								if(this.showformList[i]=='pictureUrl')
								{
									this.$message.error('上传图片未填写，请完整填写信息后提交')
									return false;
								}
							}
							else
							{
								if(this.showformList[i]=='videoUrl')
								{
									this.$message.error('上传视频未填写，请完整填写信息后提交')
									return false;
								}
							}
						}
						else
						{
							if(this.showformList[i]=='pictureUrl')
							{
								this.$message.error('上传图片未填写，请完整填写信息后提交')
								return false;
							}
						}
						if(this.showformList[i]=='chnanelTypeName')
						{
							this.$message.error('客户端未填写，请完整填写信息后提交')
							return false;
						}
						else if(this.showformList[i]=='pictureName')
						{
							this.$message.error('请输入图片名称')
							return false;
						}
						else if(this.showformList[i]=='sort')
						{
							this.$message.error('排序未填写，请完整填写信息后提交')
							return false;
						}
						else
						{
							
						}
					}
				}
			},
			// 判断是否是正整数
			sortValue(e)
			{
				if(e.currentTarget.value<=0)
				{
					this.$message.error('只能输入正整数');
					return false;
				}
			},
			
			// 上传单选
			radioData(e)
			{
				if(e==1)
				{
					this.isradio=true;
					this.form.videoUrl=''
					this.ispictureUrl=false;
				}
				else
				{
					this.isradio=false;
					this.form.pictureUrl=''
					this.isvideoUrl=false;
				}
			},
			
			mouseover()
			{
				this.move=true;
			},
			mouseleave()
			{
				this.move=false;
			},
			moveClick()
			{
				this.form.pictureUrl='';
				this.ispictureUrl=false;
			}
		}
	}
</script>

<style>
	@import '../assets/table.css';
	.crumbs-box{
		background-color: #F2F2F2;
		padding-left: 10px;
	}
	.crumbs{
		width: 100%;
		padding: 10px 0px 10px;
	}
	.selectbox{
		 margin-top: 10px;
		 margin-bottom: 20px;
	}
	.title{
		line-height: 30px;
		text-align: right;
	}
	.selectInputBox{
		margin-right: 20px;
	}
	.select{
		width: 100%;
		height: 30px;
		padding-left: 5px;
	}
	.formbox{
		background-color: #F2F2F2;
		padding-left: 10px;
	}
	.tablebox{
		width: 98%;
		background-color: #E4E4E4;
		overflow: scroll;
	}
	.table-trtitle{
		height: 50px;
		background-color: white;
		margin-top: 10px;
	}
	#add{
		margin-left: 3%;
		padding-top: 10px;
	}
	.add-title{
		text-align: left;
		margin-top: 20px;
		margin-bottom: 20px;
		font-weight: bold;
		color: black;
	}
	.size{
		margin-top: 10px;
		text-align: left;
	}
	td span{
		margin-left: 5px;
		margin-right: 5px;
	}
	.form-img{
		width: 148px;
		height: 148px;
		float: left;
	}
	.imghover{
		width: 148px;
		height: 148px;
	}
	.icon{
		width: 148px;
		height: 148px;
		font-size: 25px;
		position: fixed;
		top: -148px;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.2);
		z-index: 9999;
		color: white;
		position: relative;
		pointer-events: none;
	}
	.icon .el-icon-delete{
		position: absolute;
		left: 44%;
		line-height: 148px !important;
		pointer-events: none;
	}
	.must{
		color: red;
	}
	.add-input .el-radio{
		float: left;
	}
</style>